export default __webpack_public_path__ + "static/media/section1-img2.92c8c0db.png";